module.exports = __webpack_public_path__ + "static/media/ic_fin_tools_risk.ae943a79.svg";